
// Solves stuff like 55.555.toFixed(2) = 55.55, not 55.56 which is correct
export const roundNumber = (num, places) => {
  return Math.round( ( +num + Number.EPSILON ) * Math.pow(10, places) ) / Math.pow(10, places);
}
